import store from '@/vuex/index';

const levelMap = {
  ERROR: 3,
  error: 3,
  warning: 2,
  WARN: 2,
  INFO: 1,
  info: 1,
  success: 0,
  SUCCESS: 0,
};

const isHide = ({ configs = {}, type, scene, entityType }) => {
  const config = configs[type] || {};
  const scenes = (config[entityType] || {}).scenes;
  return scenes && scenes.includes(scene);
};

const compressionLabels = (labels, compression) => {
  let result = [];
  let infos = [];
  labels.forEach((label) => {
    if (compression) {
      if (label.level !== 'INFO' || label.noCompression) result.push(label);
      else infos.push(label);
    } else {
      result.push(label);
    }
  });
  return { result, infos };
};

const labelsFilter = (labels, configs, scene, entityType, typeKey = 'type') => {
  return labels
    .filter(
      (item) =>
        item.hide !== 'Y' &&
        (item.level === 'ERROR' ||
          !isHide({
            configs,
            type:
              typeof item[typeKey] === 'number'
                ? item.labelType
                : item[typeKey] || item.type || item.code || item.labelType,
            scene,
            entityType,
          }))
    )
    .sort((a, b) => levelMap[b.level || b.type] - levelMap[a.level || b.type]);
};

// 排序处理,info压缩等处理
export function transLabels({ labels, compression, scene, entityType }) {
  const configs = store.getters.getLabelConfig || {};
  if (!labels || !Array.isArray(labels)) return [];
  const _labels = labelsFilter(labels, configs, scene, entityType);
  const { result, infos } = compressionLabels(_labels, compression);
  if (infos.length) result.push({ ...infos[0], name: infos.map((i) => i.name).join('/'), toast: '' });
  return result;
}

/**
 * @param props
 * @param props.compression 是否压缩
 * @param props.entityType 表单类型
 * @param props.labels 标签列表
 * @param props.scene 场景 101 | 102
 * @param props.typeKey 标签type的key
 * @returns {[]|*[]}
 */
export default function useLabels(props) {
  const { compression, entityType, labels, scene, typeKey } = props;
  return transLabels({ labels, compression, scene: scene || 101, entityType, typeKey });
}
